/* ===============================================
#Splide RTL（アラビア語）
splide.min.js の後・custom.js の前に読み込むこと
=============================================== */
(function () {
  'use strict';

  function getPageIndex(splide) {
    if (splide.Components && splide.Components.Controller) {
      return splide.Components.Controller.toPage(splide.index);
    }
    return splide.index;
  }

  function getScrollbarPositionPercent(rate, maxScrollableDistance) {
    const clampedRate = Math.max(0, Math.min(rate, 1));
    const position = maxScrollableDistance - clampedRate * maxScrollableDistance;
    return Math.min(position, maxScrollableDistance);
  }

  function getScrollbarRateFromPosition(positionPercent, maxScrollableDistance) {
    if (maxScrollableDistance <= 0) {
      return 0;
    }
    const clampedPosition = Math.max(0, Math.min(positionPercent, maxScrollableDistance));
    const rate = clampedPosition / maxScrollableDistance;
    return 1 - rate;
  }

  function flipPaddingForRtl(padding) {
    if (!padding) {
      return padding;
    }

    if (typeof padding === 'object' && padding.right !== undefined) {
      return { left: padding.right };
    }

    if (typeof padding === 'string') {
      return { left: padding };
    }

    return padding;
  }

  function applyRtlSplideOptions(options) {
    const nextOptions = Object.assign({}, options, { direction: 'rtl' });

    if (nextOptions.padding !== undefined) {
      nextOptions.padding = flipPaddingForRtl(nextOptions.padding);
    }

    if (nextOptions.breakpoints) {
      nextOptions.breakpoints = Object.assign({}, nextOptions.breakpoints);

      Object.keys(nextOptions.breakpoints).forEach(function (breakpointKey) {
        const breakpointOptions = nextOptions.breakpoints[breakpointKey];

        if (!breakpointOptions || breakpointOptions.padding === undefined) {
          return;
        }

        nextOptions.breakpoints[breakpointKey] = Object.assign({}, breakpointOptions, {
          padding: flipPaddingForRtl(breakpointOptions.padding),
        });
      });
    }

    return nextOptions;
  }

  function initRtlSplideScrollbar(splide, containerElement) {
    const scrollbar = containerElement.querySelector('.custom-splide__scrollbar');
    let handle = containerElement.querySelector('.custom-splide__scrollbar__handle');

    if (!scrollbar || !handle) {
      return;
    }

    if (handle.dataset.customRtlScrollbarBound) {
      return;
    }

    const freshHandle = handle.cloneNode(true);
    handle.parentNode.replaceChild(freshHandle, handle);
    handle = freshHandle;
    handle.dataset.customRtlScrollbarBound = 'true';

    const dragState = {
      isDragging: false,
      startX: 0,
      startLeft: 0,
    };

    function updateScrollbar() {
      const totalSlides = splide.length;
      const visibleSlides = splide.options.perPage;
      const pageIndex = getPageIndex(splide);
      const end = totalSlides - visibleSlides;

      if (end <= 0) {
        handle.style.width = '100%';
        handle.style.left = '0%';
        return;
      }

      const handleWidth = (visibleSlides / totalSlides) * 100;
      const maxScrollableDistance = 100 - handleWidth;
      const rate = pageIndex / end;

      handle.style.width = `${handleWidth}%`;
      handle.style.left = `${getScrollbarPositionPercent(rate, maxScrollableDistance)}%`;
    }

    handle.addEventListener('mousedown', function (event) {
      event.preventDefault();
      dragState.isDragging = true;
      dragState.startX = event.clientX;
      dragState.startLeft = parseFloat(handle.style.left || '0');
      document.body.style.userSelect = 'none';
    });

    const handleMouseMove = function (event) {
      if (!dragState.isDragging) {
        return;
      }

      const scrollbarWidth = scrollbar.offsetWidth;
      const handleWidth = handle.offsetWidth;
      const deltaX = event.clientX - dragState.startX;
      const directionalDelta = -deltaX;
      const handleWidthPercent = (handleWidth / scrollbarWidth) * 100;
      const maxScrollableDistance = 100 - handleWidthPercent;
      let newLeft = dragState.startLeft + (directionalDelta / scrollbarWidth) * 100;
      newLeft = Math.max(0, Math.min(newLeft, maxScrollableDistance));
      handle.style.left = `${newLeft}%`;

      const totalSlides = splide.length;
      const visibleSlides = splide.options.perPage;
      const end = totalSlides - visibleSlides;

      if (end > 0 && maxScrollableDistance > 0) {
        const rate = getScrollbarRateFromPosition(newLeft, maxScrollableDistance);
        const newIndex = Math.round(rate * end);

        if (splide.options.type === 'loop') {
          splide.go(newIndex % totalSlides);
        } else {
          splide.go(Math.min(newIndex, end));
        }
      }
    };

    const handleMouseUp = function () {
      if (!dragState.isDragging) {
        return;
      }

      dragState.isDragging = false;
      document.body.style.userSelect = '';
      updateScrollbar();
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    splide.on('destroy', function () {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    });

    splide.on('mounted move resize', updateScrollbar);
    updateScrollbar();

    return updateScrollbar;
  }

  function initRtlSplideWheelScroll(splide, sliderElement, options) {
    const element = sliderElement || splide.root;

    if (!element || element.dataset.customRtlWheelBound) {
      return;
    }

    element.dataset.customRtlWheelBound = 'true';

    const throttleTime = (options && options.throttleTime) || 600;
    const scrollThreshold = (options && options.scrollThreshold) || 150;
    let isScrolling = false;
    let accumulatedScroll = 0;
    let resetTimer = null;

    const wheelHandler = function (event) {
      const deltaX = event.deltaX;
      const deltaY = event.deltaY;

      if (Math.abs(deltaX) <= Math.abs(deltaY) || deltaX === 0) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isScrolling) {
        return;
      }

      accumulatedScroll += Math.abs(deltaX);

      if (accumulatedScroll >= scrollThreshold) {
        isScrolling = true;

        if (deltaX > 0) {
          splide.go('<');
        } else {
          splide.go('>');
        }

        accumulatedScroll = 0;
        if (resetTimer) {
          clearTimeout(resetTimer);
          resetTimer = null;
        }

        setTimeout(function () {
          isScrolling = false;
        }, throttleTime);
      } else {
        if (resetTimer) {
          clearTimeout(resetTimer);
        }
        resetTimer = setTimeout(function () {
          accumulatedScroll = 0;
          resetTimer = null;
        }, 200);
      }
    };

    element.addEventListener('wheel', wheelHandler, { passive: false, capture: true });

    splide.on('destroy', function () {
      element.removeEventListener('wheel', wheelHandler, { capture: true });
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }
    });
  }

  function patchSectionSlideCounter(splide) {
    const updateCounter = function () {
      const current = document.getElementById('slide-current');
      const length = document.getElementById('slide-length');

      if (current) {
        current.textContent = getPageIndex(splide) + 1;
      }
      if (length) {
        length.textContent = splide.length;
      }
    };

    splide.on('active move', updateCounter);
    updateCounter();
  }

  function patchSplideInstance(splide) {
    const root = splide.root;

    if (!root || root.dataset.customRtlSplidePatched) {
      return;
    }

    root.dataset.customRtlSplidePatched = 'true';

    if (root.classList.contains('custom-section-slide__slider')) {
      patchSectionSlideCounter(splide);
    }

    const scrollbarContainer = root.classList.contains('custom-section-slide__slider')
      ? root.closest('section') || document
      : root;

    if (scrollbarContainer.querySelector('.custom-splide__scrollbar')) {
      initRtlSplideScrollbar(splide, scrollbarContainer);
    }

    initRtlSplideWheelScroll(splide, root);
  }

  function wrapSplideConstructor() {
    if (!window.Splide || window.Splide.__customRtlWrapped) {
      return;
    }

    const OriginalSplide = window.Splide;

    function WrappedSplide(element, options) {
      const root = typeof element === 'string' ? document.querySelector(element) : element;
      const instance = new OriginalSplide(element, applyRtlSplideOptions(options || {}));
      const originalMount = instance.mount.bind(instance);

      instance.mount = function () {
        const result = originalMount.apply(this, arguments);
        queueMicrotask(function () {
          patchSplideInstance(instance);
        });
        return result;
      };

      return instance;
    }

    Object.assign(WrappedSplide, OriginalSplide);
    WrappedSplide.__customRtlWrapped = true;
    window.Splide = WrappedSplide;
  }

  function patchExistingSplides() {
    document.querySelectorAll('.splide').forEach(function (root) {
      if (root.splide) {
        patchSplideInstance(root.splide);
      }
    });
  }

  wrapSplideConstructor();

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(patchExistingSplides, 0);
  });
})();
